import Workplan from "../components/workplan/Workplan";
import { summaryCounts, nodesForPhase } from "../components/workplan/util";

// The Theme -> Epic -> Task workplan page for one phase (2 and 3 share it).
export default function PhaseWorkplanView({ phaseId, title, weeks, state, setState, isAdmin, goHome, setSavedAt }) {
  const nodes = nodesForPhase(state.workplan, phaseId);
  const { total, done, doing, todo } = summaryCounts(nodes);
  const pct = total ? Math.round((done / total) * 100) : 0;

  const onChange = (next) => {
    setState(next);
    setSavedAt && setSavedAt("Saved · " + new Date().toLocaleTimeString());
  };

  return (
    <div className="view" data-testid={`phase${phaseId}-view`}>
      <div className="crumb">
        <a onClick={goHome} data-testid="back-to-phases">← All phases</a>
        {" / "}
        Phase {phaseId} · {title}
      </div>

      <div className="summary-grid">
        <div className="stat big">
          <div className="stat-label">Phase {phaseId} Progress · {weeks}-week sprint</div>
          <div className="stat-num" data-testid={`phase${phaseId}-pct`}>
            <span>{pct}</span>%
          </div>
          <div className="bar-track">
            <div className="bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <div className="stat">
          <div className="stat-label">Done</div>
          <div className="stat-num" data-testid="wp-count-done">{done}<span className="of">/{total}</span></div>
        </div>
        <div className="stat">
          <div className="stat-label">In Progress</div>
          <div className="stat-num" data-testid="wp-count-doing">{doing}<span className="of">/{total}</span></div>
        </div>
        <div className="stat">
          <div className="stat-label">Not Started</div>
          <div className="stat-num" data-testid="wp-count-todo">{todo}<span className="of">/{total}</span></div>
        </div>
      </div>

      <div className="sec-head">Phase {phaseId} Workplan</div>
      <div className="sec-desc">
        The full Theme → Epic → Task breakdown. Check off leaf tasks; epic and theme bars
        roll up automatically. Toggle between List, Kanban, By-owner, and Timeline.
      </div>

      <Workplan state={state} setState={onChange} isAdmin={isAdmin} phaseId={phaseId} weeks={weeks} />
    </div>
  );
}
